import { getBundleParams } from "../utils"

export const getServiceUrl = () => getBundleParams().memoToolServiceUrl
